"use client";

import { useEffect } from "react";

const LOCALE_MAP: Record<string, string> = {
  "en-US": "en",
  "en-GB": "en",
};

export function LangSetter() {
  useEffect(() => {
    const match = document.cookie.match(/(?:^|;\s*)NEXT_LOCALE=([^;]*)/);
    if (match) {
      const raw = match[1];
      document.documentElement.lang = LOCALE_MAP[raw] || raw;
    }
  }, []);
  return null;
}
